module.exports = __webpack_public_path__ + "static/imac@2x-d6baf606c5b46d66b27314f78ba7297b.png";